// @ts-nocheck
import { message } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import {
  selectCampaignForUpdate,
  setCampaignForUpdate,
  setIsCampaignForUpdate,
} from "../../../redux";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { campaignsService } from "../../../shared/services";

export const useCampaignsById = () => {
  const [isValidate, setIsValidate] = useState(false);
  const { pathname } = useLocation();
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const campaignForUpdate = useSelector(selectCampaignForUpdate);

  const getSingleCampaign = async (campaignId: number) => {
    return await campaignsService
      .get(campaignId)
      .then((res) => res)
      .catch((err: any) => {
        console.log(err);
        navigate(`/campaigns`);
        message.error(err.message);
      });
  };

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      if (id === "new" || pathname === "/campaigns/new") {
        dispatch(setIsCampaignForUpdate(false));
        if (!cancelled) setIsValidate(true);
        return;
      }

      const campaignId = Number(id);
      if (!Number.isFinite(campaignId) || campaignId <= 0) {
        navigate(`/campaigns`);
        return;
      }

      dispatch(setIsCampaignForUpdate(true));

      if (Number(campaignForUpdate?.id) === campaignId) {
        if (!cancelled) setIsValidate(true);
        return;
      }

      setIsValidate(false);
      const res = await getSingleCampaign(campaignId);
      if (cancelled || !res) return;

      dispatch(setCampaignForUpdate(res));
      setIsValidate(true);
    };

    void load();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, id]);

  return {
    isValidate,
  };
};
